import {unsafe_selectWithState} from '../../redux/utils'
import {isLicenseExpired, isLicenseTrialWithoutRenewal} from '../../activeLicenseInfo/selectors'
import {isFirstAdmin} from '../../loggedInUser/selectors'

export default function isFirstAdminWithTrialOnly() {
    return unsafe_selectWithState(isFirstAdmin) && unsafe_selectWithState(isLicenseTrialWithoutRenewal) && !unsafe_selectWithState(isLicenseExpired)
}



// WEBPACK FOOTER //
// ./web/js/userEvents/checks/isFirstAdminWithTrialOnly.js